document.addEventListener('DOMContentLoaded', () => {
  const getAppButton = document.querySelector('.js-get-app-button');

  if (!getAppButton) return;

  getAppButton.addEventListener('click', () => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    const url = isIOS
      ? 'https://app.appsflyer.com/id1584370233?pid=12&utm_source=footer'
      : 'https://app.appsflyer.com/live.yasno.app?pid=12&utm_source=footer';

    window.location.href = url;
  });
});
